import { Omit } from '@40seas/entities/common';
import { SegmentEntityFieldsArray } from '@40seas/models';
import { AiprizeCompany } from './aiprize.company.entity';

export class CreateAiprizeCompanyDto extends Omit(AiprizeCompany, [...SegmentEntityFieldsArray, 'status']) {}
